import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiTrendingUp, FiTrendingDown, FiMinus, FiAward } from 'react-icons/fi';
import { leaderboardData } from '../data/mockData';

export default function Leaderboard() {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="flex items-center gap-4 mb-8">
        <div className="p-3 bg-trophy-500/20 rounded-xl border border-trophy-500/30">
          <SafeIcon icon={FiAward} className="text-2xl text-trophy-500" />
        </div>
        <div>
          <h1 className="text-3xl font-bold">Global Rankings</h1>
          <p className="text-gray-400">Current Season: Cybernetic Dawn</p>
        </div>
      </div>

      <div className="bg-navy-900 rounded-2xl border border-navy-700 overflow-hidden">
        <div className="grid grid-cols-12 gap-4 p-4 border-b border-navy-700 bg-navy-800/50 text-xs font-mono text-gray-400 uppercase tracking-wider">
          <div className="col-span-2 md:col-span-1 text-center">Rank</div>
          <div className="col-span-7 md:col-span-8">Candidate</div>
          <div className="col-span-3 text-right">XP Score</div>
        </div>

        <div className="divide-y divide-navy-800">
          {leaderboardData.map((user, idx) => (
            <motion.div 
              key={user.name}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: idx * 0.05 }}
              className={`grid grid-cols-12 gap-4 p-4 items-center transition-colors hover:bg-navy-800/50 ${
                user.isMe ? 'bg-quest-500/5 border-l-4 border-l-quest-500' : 'border-l-4 border-l-transparent'
              }`}
            >
              <div className="col-span-2 md:col-span-1 flex flex-col items-center justify-center">
                <span className={`text-lg font-bold ${
                  user.rank === 1 ? 'text-trophy-500' :
                  user.rank === 2 ? 'text-gray-300' :
                  user.rank === 3 ? 'text-amber-600' : 'text-gray-500'
                }`}>
                  #{user.rank}
                </span>
                <div className="text-[10px] mt-1">
                  {user.trend === 'up' && <SafeIcon icon={FiTrendingUp} className="text-quest-500" />}
                  {user.trend === 'down' && <SafeIcon icon={FiTrendingDown} className="text-neon-pink" />}
                  {user.trend === 'same' && <SafeIcon icon={FiMinus} className="text-gray-500" />}
                </div>
              </div>
              
              <div className="col-span-7 md:col-span-8 flex items-center gap-3">
                <div className="relative">
                  <img src={user.avatar} alt={user.name} className="w-10 h-10 rounded-full border border-navy-600" />
                  {user.rank <= 3 && (
                    <div className="absolute -top-2 -right-2">
                       <SafeIcon icon={FiAward} className={
                         user.rank === 1 ? 'text-trophy-500' :
                         user.rank === 2 ? 'text-gray-300' : 'text-amber-600'
                       } />
                    </div>
                  )}
                </div>
                <div>
                  <div className={`font-medium ${user.isMe ? 'text-quest-500' : 'text-white'}`}>
                    {user.name} {user.isMe && '(You)'}
                  </div>
                </div>
              </div>
              
              <div className="col-span-3 text-right font-mono text-sm md:text-base">
                {user.xp.toLocaleString()}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}